import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import PrimaryButton from "../PrimaryButton";
import { fetchImageById } from "../../services/AllServices";

const ImageComponent = ({ imageId = "" }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  
  const handlePreviewClick = async (e) => {
    try {
      e?.preventDefault();
      const responseData = await fetchImageById(imageId);
      let imageBlobUrl = URL.createObjectURL(responseData);

      setImageUrl(imageBlobUrl);
      setShowPreview(!showPreview);
    } catch (error) {
      console.error(error);
      throw error || new Error("API Error");
    }
  };

  const handleClose = () => {
    setShowPreview(false);
  };
  return (
    <div>
      <div>
        <PrimaryButton type="submit" text="View" onClick={handlePreviewClick} />
      </div>
      <Modal show={showPreview} onHide={handlePreviewClick}>
        <Modal.Header className="d-flex justify-content-center">
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={imageUrl}
            alt="Not found"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "100%",
              maxHeight: "80vh",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default React.memo(ImageComponent);
